import React, { useEffect, useState } from "react";
import { FAN_ACCOUNT_EVENT, getFanUser } from "../lib/fanAccount";
import { SAVED_TALENT_EVENT, SavedTalent, listSaved, syncSaved } from "../lib/savedTalent";
import { absMediaUrl } from "../utils/mediaUrl";
import { DEFAULT_AVATAR_SRC, showDefaultAvatar } from "../lib/defaultAvatar";
import { t } from "../i18n";
import "./SavedTalentRow.css";

// "Saved" — the talent a fan hearted (1.5.3, founder 10/26), under the
// Industry Leaders carousel on Browse and in the talent's Discover. Newest
// first, a row the finger swipes; each card opens that talent's page. Honest
// empty state: nothing saved = no row at all. The list is the device's,
// mirrored from the account for a signed-in fan (lib/savedTalent): the first
// time this screen shows in an app session it asks the account once.

type Props = {
  /** Open a talent (the Browse screen's own rule: fan page with a back arrow). */
  onOpen: (slug: string) => void;
};

export default function SavedTalentRow({ onOpen }: Props) {
  const [saved, setSaved] = useState<SavedTalent[]>(() => listSaved());

  useEffect(() => {
    const read = () => setSaved(listSaved());
    const sync = () => {
      syncSaved(getFanUser()?._id).catch(() => {});
    };
    read();
    sync();
    window.addEventListener(SAVED_TALENT_EVENT, read);
    window.addEventListener("storage", read);
    // The fan's session usually resolves a beat after the screen opens.
    window.addEventListener(FAN_ACCOUNT_EVENT, sync);
    return () => {
      window.removeEventListener(SAVED_TALENT_EVENT, read);
      window.removeEventListener("storage", read);
      window.removeEventListener(FAN_ACCOUNT_EVENT, sync);
    };
  }, []);

  if (!saved.length) return null;
  return (
    <section className="saved-row" aria-label={t("savedTalentRow.saved")}>
      <h2 className="saved-row-title">{t("savedTalentRow.saved")}</h2>
      <div className="saved-row-track">
        {saved.map((s) => (
          <button key={s.slug} type="button" className="saved-card" title={s.name} onClick={() => onOpen(s.slug)}>
            <span className="saved-card-img">
              <img src={absMediaUrl(s.avatarUrl) || DEFAULT_AVATAR_SRC} alt="" loading="lazy" draggable={false} onError={showDefaultAvatar} />
            </span>
            <span className="saved-card-name">{s.name}</span>
          </button>
        ))}
      </div>
    </section>
  );
}
